/*
 * /plans: the limited dashboard's Plans nav item (FreeEventLimited opens the
 * sheet over its own screen there). This route only renders when that shell
 * hasn't taken over:
 *  - session not landed yet (a reload): render nothing and keep the URL, so
 *    the limited shell finds /plans once `free_event` arrives. Without this
 *    route the `/:slug` wildcard sent a reload to the /ch/plans gallery lookup;
 *  - session landed and no limited shell: the full app, so open the plan
 *    sheet over /channels.
 */
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectSessionUserLoaded, selectSessionLoadFailed } from "containers/App/selectors";

const selectLoaded = selectSessionUserLoaded();
const selectFailed = selectSessionLoadFailed();

const PlansRoute = () => {
  const loaded = useSelector(selectLoaded);
  const failed = useSelector(selectFailed);
  if (!loaded && !failed) return null;
  return <Navigate to="/channels?plans=open" replace />;
};

export default PlansRoute;
